
import './App.css';
import Routing from './pages/Routing';

function App() {
  return (
    <>
    <Routing/>

    </>
  );
}

export default App;
